import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CourseCard = ({ course }) => {
    return (
        <motion.div whileHover={{ y: -5, scale: 1.02 }} className="card h-full flex flex-col overflow-hidden">
            <div className="relative w-full h-48 overflow-hidden bg-gray-200 dark:bg-gray-800 shrink-0">
                <img 
                    src={course.imageUrl || 'https://via.placeholder.com/400x225.png?text=AircoreDynamics'} 
                    alt={`${course.title} - ${course.difficulty || 'Aviation'}`} 
                    className="absolute inset-0 w-full h-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
            </div>
            <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold mb-2">{course.title}</h3>
                <p className="text-sm opacity-70 mb-4 flex-grow">{course.description.substring(0, 100)}...</p>
                
                {/* Stats */}
                <div className="flex items-center gap-4 text-xs opacity-60 mb-4">
                    {course.difficulty && (
                        <span className="px-2 py-1 bg-light-primary/10 dark:bg-dark-primary/10 rounded">
                            {course.difficulty}
                        </span>
                    )}
                    {course.enrollmentCount > 0 && (
                        <span>{course.enrollmentCount.toLocaleString()} enrolled</span>
                    )}
                </div>
                
                <Link to={`/courses/${course.slug || course._id}`} className="btn-secondary mt-auto text-center">
                    Check Out the Course
                </Link>
            </div>
        </motion.div>
    );
};

export default CourseCard;